import { watch } from 'vue'
import { wordCount } from '@modules/app-steps/step-two/tabs/upload/state'

export const useUploadRelease = (releaseContents, updateOrder) => {
  watch(
    () => releaseContents?.value,
    (releaseFile) => {
      updateOrder(
        { releaseContents: releaseFile },
        ({ pressReleaseContent = {} }) => {
          wordCount.value = pressReleaseContent.wordCount
        }
      )
    }
  )

  return { wordCount }
}
